import { gql } from "@apollo/client";

export const CREATE_PRODUCT = gql`
  mutation CreateProductMutation($input: CreateProductInput!) {
    createProduct(input: $input) {
      ok
      error
      id
    }
  }
`;

export const UPDATE_PRODUCT = gql`
  mutation UpdateProductMutation($id: Int!, $input: UpdateProductInput!) {
    updateProduct(id: $id, input: $input) {
      ok
      error
    }
  }
`;

export const REMOVE_PRODUCT = gql`
  mutation RemoveProductMutation($id: Int!) {
    removeProduct(id: $id) {
      ok
      error
    }
  }
`;

export const PRODUCT = gql`
  query ProductQuery($id: Int!) {
    product(id: $id) {
      ok
      error
      result {
        id
        name
        url
        imgUrl
        reference
        lastPrice
        priceOnly
        totalStock
        totalGiven
      }
    }
  }
`;

export const PRODUCTS = gql`
  query ProductsQuery($offset: Int, $limit: Int, $where: ProductsFiltersInput!) {
    products(offset: $offset, limit: $limit, where: $where) {
      ok
      error
      hasMore
      total
      results {
        id
        name
        url
        imgUrl
        reference
        lastPrice
        priceOnly
        totalStock
      }
    }
  }
`;
